import React, { useState, useEffect } from "react";
import "./Support.css";
import { useNavigate } from "react-router-dom";
import logo from "./media/logo.png";
import QRCode from "./media/qr_code.svg";

const NAV_ITEMS = [ { label: "About Us", path: "/about", type: "page" }, { label: "Our Team", path: "/team", type: "page" }, { label: "Services", path: "/#services", type: "scroll" }, { label: "Contact", path: "/contact", type: "page" } ];

function Support() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.type === "scroll") {
        navigate("/");
        setTimeout(() => { document.querySelector(item.path.replace("/", "")).scrollIntoView({ behavior: "smooth" }); }, 100);
    } else {
        navigate(item.path);
        window.scrollTo(0, 0);
    }
  };

  const services = [
    { title: "Notarial Services", desc: "Official notarization to authenticate and certify your legal documents." },
    { title: "Oath Commissioning", desc: "Our commissioners administer oaths and affirmations for affidavits." },
    { title: "Corporate Secretarial", desc: "Professional services to ensure compliance with corporate governance." },
    { title: "Financial Advisory", desc: "Expert guidance on financial planning, investments, and asset management." },
    { title: "Tax Advisory", desc: "Strategic tax planning and consultancy to optimize your tax obligations." },
    { title: "Pro Bono Legal Aid", desc: "Free legal representation for children to ensure their rights and protection." },
    { title: "Common Law Assistance", desc: "Comprehensive legal support in common law matters, including contracts." },
  ];

  return (
    <div className="App support-page-wrapper">
      <div className={`dimming-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>
      <header className={`App-header ${scrolled ? "scrolled" : ""}`}>
        <a className="logo" href="/" onClick={(e) => { e.preventDefault(); navigate("/"); }}><img src={logo} alt="Logo" className="header-logo" /></a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}><div className="bar"></div><div className="bar"></div><div className="bar"></div></div>
      </header>
      <nav className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <ul>{NAV_ITEMS.map((item, i) => <li className="dropdown-item" key={i}><a onClick={() => handleNav(item)}>{item.label}</a></li>)}</ul>
      </nav>

      <section className="support-hero">
        <div className="container">
          <h1>Support Services</h1>
          <div className="support-divider"></div>
        </div>
      </section>

      <section className="section white-bg">
        <div className="container support-grid">
          {services.map((s, i) => (
            <div className="support-card" key={i}>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <footer className="App-footer">
        <div className="qr-box"><img src={QRCode} alt="QR" /></div>
        <p>© 2025 MERKEL & ASSOCIATES ADVOCATES.</p>
      </footer>
    </div>
  );
}
export default Support;